"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
var utils_1 = require("./utils");
var lodash_1 = require("lodash");
var getters_1 = require("../getters");
var __1 = require("..");
var Type;
(function (Type) {
    Type["ARRAY"] = "array";
    Type["BOOLEAN"] = "boolean";
    Type["DATE"] = "date";
    Type["NUMBER"] = "number";
    Type["OBJECT"] = "object";
    Type["STRING"] = "string";
    Type["UNDEFINED"] = "undefined";
})(Type = exports.Type || (exports.Type = {}));
var typeMap = (_a = {},
    _a[Type.ARRAY] = getters_1.arrayOr,
    _a[Type.BOOLEAN] = getters_1.booleanOr,
    _a[Type.DATE] = getters_1.dateOr,
    _a[Type.NUMBER] = getters_1.numberOr,
    _a[Type.OBJECT] = getters_1.objectOr,
    _a[Type.STRING] = getters_1.stringOr,
    _a);
function jsType(value) {
    return typeof value;
}
function dotCount(value) {
    return (value.match(/./g) || []).length;
}
function mapType(value) {
    return lodash_1.isArray(value) ? Type.ARRAY : [].concat(value).map(function (val) {
        if (utils_1.isDate(val))
            return Type.DATE;
        return jsType(val);
    }).filter(function (val) { return val !== undefined; }).shift();
}
exports.mapType = mapType;
/**
 * A bit ugly, but we want to find the appropriate getters for members of
 * your class.
 *
 * @param obj Some object
 * @param key A key for said object
 */
function findAppropriateGetter(obj, key) {
    __1.Log.info('FINDING FOR ', obj, key, ' = ', utils_1.getValueFromString(obj, key));
    return typeMap[mapType(utils_1.getValueFromString(obj, key))];
}
exports.findAppropriateGetter = findAppropriateGetter;
function appendPath(parent, child) {
    return (parent) ? parent + "." + child : child;
}
exports.appendPath = appendPath;
function findAllDotPaths(json, parent) {
    if (parent === void 0) { parent = ''; }
    return (json) ? lodash_1.flatMapDeep(Object.keys(json), function (key) {
        var currentPath = appendPath(parent, key);
        return (typeof json[key] === 'object' && !lodash_1.isArray(json[key])) ?
            [currentPath].concat(findAllDotPaths(json[key], currentPath)) :
            currentPath;
    }) : [];
}
exports.findAllDotPaths = findAllDotPaths;
function doFullPathsMatch(a, b) {
    return lodash_1.isEqual(a.split('.').map(lodash_1.camelCase), b.split('.').map(lodash_1.camelCase));
}
exports.doFullPathsMatch = doFullPathsMatch;
function doesPathMatchGreedy(a, b) {
    return a.split('.').map(lodash_1.camelCase).pop() ===
        b.split('.').map(lodash_1.camelCase).pop();
}
exports.doesPathMatchGreedy = doesPathMatchGreedy;
function doPathsMatch(target, source) {
    return doFullPathsMatch(target, source) ||
        doesPathMatchGreedy(target, source);
}
exports.doPathsMatch = doPathsMatch;
function findMatchingFields(key, json, ingorePaths) {
    if (ingorePaths === void 0) { ingorePaths = ''; }
    var ignoreable = [].concat(ingorePaths);
    return lodash_1.reduce([].concat(findAllDotPaths(json)), function (acc, dotPath) {
        return !ignoreable.find(function (path) { return doFullPathsMatch(dotPath, path); }) && doPathsMatch(key, dotPath) ? acc.concat(dotPath) : acc;
    }, []).sort(function (a, b) { return dotCount(a) > dotCount(b) ? 1 : -1; });
}
exports.findMatchingFields = findMatchingFields;
//# sourceMappingURL=finders.js.map